import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SecurityService } from "../../../core/services/security.service";

@Component({
    selector: 'confirm-user-password',
    templateUrl: './confirm-user-password.component.html',
    styleUrls: [
        './confirm-user-password.component.scss',
        '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
    ]
})
export class ConfirmUserPasswordComponent {

    @Input() userName: string;
    @Input() bearerToken: string;

    @Output() onContinueEvent: EventEmitter<any> = new EventEmitter();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter();

    password: string;
    loginFailed: boolean = false;
    loading: boolean = false;

    constructor(
        private securityService: SecurityService
    ) { }

    cancel() {
        this.onCancelEvent.emit();
    }

    continue() {
        if (this.passwordIsEmpty) {
            return;
        }

        this.loading = true;
        this.securityService.verifyUserPassword(this.password, this.bearerToken).subscribe(resp => {
            if (resp.data == true) {
                this.onContinueEvent.emit();
            }
            else {
                this.loginFailed = true;
            }

            this.loading = false;
        });
    }

    get passwordIsEmpty(): boolean {
        return this.password == null || this.password.trim() == '';
    }
}